import { customFetch } from 'utils/http';
import { processChangeEmailResponse } from 'services/production/utils/processChangeEmailResponse';
import { getM8UserURL } from 'services/production/utils/getM8URL';

type Params = {
  newEmail: string;
  password: string;
};

export const changeClientEmail = async (params: Params) => {
  const { newEmail, password } = params;

  const fetchURL = getM8UserURL('changeEmail');

  const body = new FormData();

  body.append('newEmail', newEmail);
  body.append('password', password);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  return processChangeEmailResponse(response);
};
